import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getExtensionRules } from '../../../../../shared/all-extension-rules';

@Component({
  selector: 'date-picker-restrictions',
  templateUrl: './date-picker-restrictions.component.html',
  standalone: false,
})
export class DatePickerRestrictionsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() shopCurrencySymbol: string;
  readonly formArrayFieldName = 'restrictionsRules';
  entities;
  restrictionsRules = getExtensionRules();
  showRules = false;
  constructor() {}
  ngOnDestroy() {}

  ngOnInit() {
    this.entities = this.restrictionsRules.map((r) => r.entity);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup']) {
      this.showRules = false;
      setTimeout(() => (this.showRules = true));
    }
  }
}
